export default "__VITE_ASSET__CbvhPPSe__"